import styled from 'styled-components';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
export const S = {
    Layout: styled.div `
    display: flex;
    flex-direction: column;
    flex-shrink: 0;

    width: 100%;
    padding: 30px 30px 40px;
  `,
    LayoutInputFields: styled.div `
    display: flex;
    flex-direction: column;

    margin-bottom: ${(props) => (props.isLast ? 0 : '30px')};
  `,
    FieldBox: styled.div `
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    padding: 9px 13px;
    background: ${(props) => props.isError
        ? SEMANTIC_COLORS.ERROR_FIELD_BOX_BACKGROUND
        : SEMANTIC_COLORS.DEFAULT_FIELD_BOX_BACKGROUND};

    border-radius: 10px;
  `,
    TextArea: styled.textarea `
    width: 100%;
    padding: 5px 13px;
    font-size: 18px;
    line-height: 23px;

    color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
    white-space: pre-wrap;
    resize: none;

    background: ${SEMANTIC_COLORS.DEFAULT_TEXTAREA_BACKGROUND};
    border: none;
    border-radius: 16px;

    &:focus {
      outline: none;
    }

    &::placeholder {
      font-size: 16px;
      line-height: 26px;
      color: ${SEMANTIC_COLORS.PLACEHOLDER_TEXT};
    }
  `,
    TextareaFeedbackErrorText: styled.div `
    margin: -8px 0 12px;
    color: ${SEMANTIC_COLORS.ERROR_TEXT};
  `,
    Description: styled.div `
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    width: 100%;
    padding: 0 20px 2px 5px;
    margin-bottom: 12px;

    font-size: 18px;
    color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
    background: ${(props) => props.isError
        ? SEMANTIC_COLORS.ERROR_DESCRIPTION_BACKGROUND
        : SEMANTIC_COLORS.DEFAULT_DESCRIPTION_BACKGROUND};

    border-radius: 10px;

    & > ul {
      font-size: 16px;
      line-height: 23px;

      & > li {
        margin-bottom: 6px;

        &::marker {
          font-size: 12px;
        }
      }
    }
  `,
    InputHidden: styled.input `
    display: none;
  `,
    LayoutCheckBox: styled.label `
    display: flex;

    width: fit-content;
    padding: 0 0 0 20px;
    margin-bottom: 6px;

    font-size: 18px;
    line-height: 26px;
    color: ${SEMANTIC_COLORS.DEFAULT_TEXT};

    cursor: pointer;
  `,
    CheckBox: styled.div `
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;

    width: 18px;
    height: 18px;
    margin: 5px 9px 0 0;

    background: ${SEMANTIC_COLORS.DEFAULT_CHECKBOX_BACKGROUND};
    border: 2px solid ${SEMANTIC_COLORS.DEFAULT_CHECKBOX_BORDER};
  `,
    FeedbackErrorText: styled.div `
    margin: 0 0 0 20px;
    color: ${SEMANTIC_COLORS.ERROR_TEXT};
    opacity: ${(props) => (props.isShow ? 1 : 0)};
  `,
    LayoutFooter: styled.div `
    display: flex;
    justify-content: center;

    width: 100%;
    margin-top: 40px;
  `,
    GapRow: styled.div `
    width: ${(props) => `${props.width}px`};
  `,
};
